<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Vom Zähler erfasste Heizkreise auswählen"}}</h4>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-xs-12">
			<center>
				<select multiple="multiple" class="multi-select" id="hcs-multi-select" name="hcs">
				{{#each availableHCs}}
					<option value="{{uniqueId}}" {{VALUE_SELECTED ../selectedHCs this}}>{{name}}</option>
				{{/each}}
				</select>
			</center>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
